module.exports = __webpack_public_path__ + "img/product-list_m8.85e21b48.png";